import React from 'react';
import PropTypes from 'prop-types';
import { Container, Icon, Message } from './EmptyState.styles';

const EmptyState = ({ icon, message }) => (
  <Container>
    <Icon className={`mdi ${icon}`} />
    <Message>{message}</Message>
  </Container>
);

EmptyState.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string.isRequired,
};

EmptyState.defaultProps = {
  icon: 'mdi-folder-outline',
};

export default EmptyState;
